import FirebaseService from "services/FirebaseService"
import AuthService from "services/AuthService"
import { AUTH_TOKEN, REF_TOKEN } from "constants/AuthConstant"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

export const initialState = {
  allowRedirect: false,
  email: localStorage.getItem("email") || null,
  loading: false,
  message: "",
  name: localStorage.getItem("name") || null,
  redirect: "",
  showMessage: false,
  token: localStorage.getItem(AUTH_TOKEN) || null,
}

export const signIn = createAsyncThunk(
  "auth/login",
  async (data, { fulfillWithValue, rejectWithValue }) => {
    const { email, password } = data
    try {
      const response = await AuthService.login({ email, password })

      const { refresh_token, token } = response
      localStorage.setItem(AUTH_TOKEN, token)
      localStorage.setItem("email", response.email)
      localStorage.setItem("name", response.fullName)
      return { ...response, admin: { email: response.email, name: response.fullName } }
    } catch (err) {
      console.error("err", err);
      return rejectWithValue(err.response?.data?.message || "Error")
    }
  }
)

export const signUp = createAsyncThunk(
  "auth/register",
  async (data, { rejectWithValue }) => {
    const { email, password } = data
    try {
      const response = await AuthService.register({ email, password })
      const token = response.data.token
      localStorage.setItem(AUTH_TOKEN, token)
      return token
    } catch (err) {
      console.error("err", err);
      return rejectWithValue(err.response?.data?.message || "Error")
    }
  }
)

export const signOut = createAsyncThunk("auth/logout", async () => {
  const response = await FirebaseService.signOutRequest()
  localStorage.removeItem(AUTH_TOKEN)
  return response.data
})

export const signInWithGoogle = createAsyncThunk(
  "auth/signInWithGoogle",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.loginInOAuth()
      const token = response.data.token
      localStorage.setItem(AUTH_TOKEN, token)
      return token
    } catch (err) {
      console.error("err", err);
      return rejectWithValue(err.response?.data?.message || "Error")
    }
  }
)

export const signInWithFacebook = createAsyncThunk(
  "auth/signInWithFacebook",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.loginInOAuth()
      const token = response.data.token
      localStorage.setItem(AUTH_TOKEN, token)
      return token
    } catch (err) {
      console.error("err", err);
      return rejectWithValue(err.response?.data?.message || "Error")
    }
  }
)

export const authSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = "/"
        state.allowRedirect = true
        state.token = action.payload.token
        state.email = action.payload.admin.email
        state.name = action.payload.name
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false
        state.token = null
        state.redirect = "/"
        state.allowRedirect = false
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false
        state.token = null
        state.redirect = "/"
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = "/"
        state.allowRedirect = true
        state.token = action.payload
      })
      .addCase(signUp.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(signInWithGoogle.pending, (state) => {
        state.loading = true
      })
      .addCase(signInWithGoogle.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = "/"
        state.allowRedirect = true
        state.token = action.payload
      })
      .addCase(signInWithGoogle.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(signInWithFacebook.pending, (state) => {
        state.loading = true
      })
      .addCase(signInWithFacebook.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = "/"
        state.allowRedirect = true
        state.token = action.payload
      })
      .addCase(signInWithFacebook.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
  },
  initialState,
  name: "auth",
  reducers: {
    authenticated: (state, action) => {
      state.loading = false
      state.redirect = "/"
      state.token = action.payload
    },
    hideAuthMessage: (state) => {
      state.message = ""
      state.showMessage = false
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload
      state.showMessage = true
      state.loading = false
    },
    showLoading: (state) => {
      state.loading = true
    },
    signInSuccess: (state, action) => {
      state.loading = false
      state.token = action.payload
      state.redirect = "/"
      state.allowRedirect = true
    },
    signOutSuccess: (state) => {
      state.loading = false
      state.token = null
      state.redirect = "/"
    },
  },
})

export const {
  authenticated,
  hideAuthMessage,
  showAuthMessage,
  showLoading,
  signInSuccess,
  signOutSuccess,
} = authSlice.actions

export default authSlice.reducer
